import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useRefreshSubscribers = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ event, page }) => handler({
    type: actions.REFRESH_SUBSCRIBERS, category, code, event, page,
  }), [category, code]);
};

const useFetchSubscribers = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({
    event, append, page, pageSize,
  }) => handler({
    type: actions.FETCH_SUBSCRIBERS, category, code, event, append, page, pageSize,
  }), [category, code]);
};

const useUpdateSubscribersFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ event, value }) => handler({
    type: actions.UPDATE_SUBSCRIBERS_FILTER, category, code, event, value,
  }), [category, code]);
};

const useUpdateSubscribersRoleFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ event, role }) => handler({
    type: actions.UPDATE_SUBSCRIBERS_ROLE_FILTER, category, code, event, role,
  }), [category, code]);
};

export default {
  useFetchSubscribers,
  useRefreshSubscribers,
  useUpdateSubscribersFilter,
  useUpdateSubscribersRoleFilter,
};
